"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
function default_1({ open, closeDialog, goToWithdrawRequestPage, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, PaperProps: {
            sx: {
                rowGap: '14px',
                width: '335px',
                padding: '14px',
                borderRadius: '12px',
                margin: 0,
            },
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '10px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-table-row", css: {
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '4px',
                            padding: '12px 14px',
                            borderRadius: '8px',
                            whiteSpace: 'pre-wrap',
                        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningTriangleRedSvg, { css: { width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4 gray-80" }, { children: t('중고/양도: 운송장 집화처리 필수') }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-60" }, { children: `(=${t('택배 기사님께서 수거하는 시점')})` }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body2 gray-80", css: { padding: '10px 0' } }, { children: `${t('[ 배송 보낸 만큼 ] 정산 접수해 주세요')} :)` }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    columnGap: '8px',
                    button: {
                        width: '100%',
                        height: '40px',
                        borderRadius: '8px',
                        fontSize: '15px',
                    },
                } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                            border: '1px solid var(--gray-10)',
                            color: 'var(--gray-80)',
                            bgcolor: 'var(--white) !important',
                        }, onClick: closeDialog }, { children: t('취소') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                            fontWeight: 'bold',
                            color: 'var(--white)',
                            bgcolor: 'var(--primary-main) !important',
                        }, onClick: () => {
                            closeDialog();
                            goToWithdrawRequestPage();
                        } }, { children: t('정산') }))] }))] })));
}
exports.default = default_1;
